import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import {
  persistCombineReducers,
  persistStore,
  createMigrate,
} from 'redux-persist';
import { createLogger } from 'redux-logger';
// @ts-ignore
import storage from 'redux-persist-indexeddb-storage';
// @ts-ignore
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import rootReducer from './reducers';
import {
  systemTransform,
  conversationTransform,
  accountInfoTransform,
} from './transforms';
import migrations from './migrations';

const persistConfig = {
  key: 'root',
  storage: storage('nuacomDB'),
  stateReconciler: hardSet,
  transforms: [systemTransform, conversationTransform, accountInfoTransform],
  version: 2,
  whitelist: ['system', 'contact', 'conversation', 'accountInfo'],
  migrate: createMigrate(migrations, { debug: false }),
};

const reducers = persistCombineReducers(persistConfig, rootReducer);
const middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  middleware.push(createLogger());
}

export const configureStore = () => {
  const store = createStore(reducers, applyMiddleware(...middleware));
  const persistor = persistStore(store);
  return { store, persistor };
};

const TypedCombineReducers = combineReducers({
  ...rootReducer,
});

// eslint-disable-next-line no-undef
export type RootState = ReturnType<typeof TypedCombineReducers>;
